/**
     * Convierte un base64 a un blob
     * @param {*} content = base 64 a convertir
     * @param {*} contentType = tipo de contenido. Ejemplo => image/png
     */
export default function convertBase64toBlob (content, contentType) {
    contentType = contentType || '';
    var sliceSize = 512;
    var byteCharacters = window.atob(content); //method which converts base64 to binary
    var byteArrays = [
    ];
    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);
        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    var blob = new Blob(byteArrays, {
        type: contentType
    }); //statement which creates the blob

    const img = new Blob([blob], { type: contentType });
        let url = URL.createObjectURL(img);
        return url;
}
